import React from 'react';
import { Routes, Route } from "react-router-dom";
import Landing from './Pages/Landing';
import Confirmation from './Pages/Confirmation';
import Navbar from './Components/Navbar';
import './App.css';
import { useTranslation } from 'react-i18next';
import { StoreCountryProvider } from './Contexts/StoreCountryContext';

function App() {
  const { i18n, ready } = useTranslation();
  if (ready) document.documentElement.dir = i18n.resolvedLanguage === "ar" ? "rtl" : "ltr";
  console.log("INIT APP");
  return (
    <>
      <StoreCountryProvider>
        <Navbar></Navbar>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="confirmation" element={<Confirmation />} />
        </Routes>
      </StoreCountryProvider>
    </>
  );
}

export default App;